<template>
  <div :id="idName">
    <div class="fuel-utilization-wo__section-header" v-if="workOrders.length">{{ status }}</div>
    <WorkOrderSummary class="fuel-utilization-wo__summary" v-for="workOrder in workOrders" :work-order="workOrder" :key="workOrder.work_order_id"></WorkOrderSummary>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import WorkOrderSummary from './work-order/WorkOrderSummary.vue';

  export default {
    name: 'StatusGroup',
    components: {
      WorkOrderSummary,
    },
    props: {
      status: {
        type: String,
        required: true
      },
      workOrders: {
        type: Array,
        default: function () { return [] }
      },
    },
    computed: {
      idName() {
        return `wo-${lodash.camelCase(this.status)}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .queue-item {
    background:$white;
    border: 1px solid $dark-silver;
    border-radius:em(3px);
    transition:.2s;
    display: flex;
    padding:em(1px);
    margin-top: em(10px);
    &:hover {
      border:1px solid $curiouser-blue;
      box-shadow: 0 em(1px) em(3px) 0 rgba(17, 118, 187, 0.35);
      cursor:pointer;
      transition:.2s;
      .queue-item--hoverable {
        background: $selago;
      }
    }
    @include m(no-hover) {
      &:hover {
        border:1px solid $alto;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.35);
        cursor:default;
        transition:.2s;
      }
    }
    @include m(no-shadow) {
      box-shadow:none;
      &:hover {
        box-shadow:none;
      }
    }
    @include e(detail) {
      border-left:1px solid $quicksilver;
      padding: 0.625em;
      &:first-of-type {
        border-left:none;
      }
      @include m(flex-container) {
        display:flex;
        flex-direction:row;
        justify-content:space-around;
      }
    }
  }
</style>
